<p-button icon="pi pi-stop-circle" label="stop"
        *ngIf="visible" (onClick)="buttonClicked()"
        [outlined]="true" severity="danger"></p-button>